<div *ngIf="isDuplicate" class="alert alert-danger">
  <strong>Fingerprint Alert! - Potential Duplicate Image</strong> This image has attributes that identically match other images submitted to this program.
  <div *ngIf="parentContentKey" class="alert alert-warning-blue"><strong>Resubmittal</strong> Possible resubmittal of same image.</div>
</div>
